import { render, staticRenderFns } from "./feedBait_sel.vue?vue&type=template&id=4fc1e91c&scoped=true"
import script from "./feedBait_sel.vue?vue&type=script&lang=js"
export * from "./feedBait_sel.vue?vue&type=script&lang=js"
import style0 from "./feedBait_sel.vue?vue&type=style&index=0&id=4fc1e91c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1e91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc1e91c')) {
      api.createRecord('4fc1e91c', component.options)
    } else {
      api.reload('4fc1e91c', component.options)
    }
    module.hot.accept("./feedBait_sel.vue?vue&type=template&id=4fc1e91c&scoped=true", function () {
      api.rerender('4fc1e91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_sel.vue"
export default component.exports